import { graphql } from '@/gql'

export const ChecklistCheckRowFragment = graphql(/* GraphQL */ `
  fragment ChecklistCheckRow on ChecklistCheck {
    id
    label
    helpText
    blocking
    allowsNotApplicable
    state
    notApplicableReason
    decidedAt
    decidedBy {
      id
      name
    }
    # Every save brings back its checklist's status and counts, so the rest of the page updates with it.
    checklist {
      id
      status
      checkCounts {
        total
        done
        notApplicable
        blockingPending
      }
    }
  }
`)

export const ChecklistCardFragment = graphql(/* GraphQL */ `
  fragment ChecklistCard on Checklist {
    id
    viewerCanDecide
    checkCounts {
      total
      done
      blockingPending
    }
    template {
      id
      name
      ownerName
    }
    checks {
      id
      state
      blocking
      ...ChecklistCheckRow
    }
  }
`)
